import { WindowTitle } from "@saleor/components/WindowTitle";
import { sectionNames } from "@saleor/intl";
import { asSortParams } from "@saleor/utils/sort";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, RouteComponentProps, Switch } from "react-router-dom";

import {
  subscriberAddPath,
  SubscriberAddUrlQueryParams,
  subscriberListPath,
  SubscriberListUrlQueryParams,
  SubscriberListUrlSortField,
  subscriberPath,
  SubscriberUrlQueryParams
} from "./urls";
import SubscriberCreateComponent from "./views/SubscriberCreate";
import SubscriberDetailsComponent from "./views/SubscriberDetails";
import SubscriberListComponent from "./views/SubscriberList";

const SubscriberList: React.FC<RouteComponentProps<{}>> = ({ location }) => {
  const qs = parseQs(location.search.substr(1));
  const params: SubscriberListUrlQueryParams = asSortParams(
    qs,
    SubscriberListUrlSortField
  );
  return <SubscriberListComponent params={params} />;
};

const SubscriberCreate: React.FC<RouteComponentProps<{}>> = ({ location }) => {
  const qs = parseQs(location.search.substr(1));
  const params: SubscriberAddUrlQueryParams = qs;
  return <SubscriberCreateComponent params={params} />;
};

const SubscriberDetails: React.FC<RouteComponentProps<{ id: string }>> = ({
  location,
  match
}) => {
  const qs = parseQs(location.search.substr(1));
  const params: SubscriberUrlQueryParams = qs;
  return (
    <SubscriberDetailsComponent
      id={decodeURIComponent(match.params.id)}
      params={params}
    />
  );
};

export const SubscriberSection: React.FC = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.subscribers)} />
      <Switch>
        <Route exact path={subscriberListPath} component={SubscriberList} />
        <Route exact path={subscriberAddPath} component={SubscriberCreate} />
        <Route path={subscriberPath(":id")} component={SubscriberDetails} />
      </Switch>
    </>
  );
};

export default SubscriberSection;
